import React, { MouseEventHandler } from 'react';
import styled from 'styled-components';

export const allMaterialSymbols = [
  'android_cell_4_bar',
  'arrow_back',
  'arrow_downward',
  'arrow_drop_down',
  'arrow_drop_up',
  'arrow_forward',
  'arrow_right',
  'arrow_upward',
  'attach_file',
  'block',
  'cancel',
  'check',
  'check_circle',
  'chevron_right',
  'close',
  'cloud',
  'content_copy',
  'done',
  'download',
  'edit',
  'error',
  'exit_to_app',
  'expand_less',
  'expand_more',
  'format_align_left',
  'help',
  'info',
  'library_books',
  'link',
  'list_alt',
  'lock',
  'menu',
  'open_in_new',
  'percent',
  'pie_chart',
  'public',
  'publish',
  'qr_code_scanner',
  'redeem',
  'schedule',
  'search',
  'settings',
  'star',
  'swap_horiz',
  'sync',
  'system_update',
  'vpn_key',
  'warning',
] as const;

// Material UI icon sizes: small = 20px, default = 24px, large = 35px
type FontSize = 'inherit' | 'small' | 'default' | 'large';

const fontSizeMap: Record<FontSize, string> = {
  inherit: 'inherit',
  small: '20px',
  default: '24px',
  large: '35px',
};

const IconSpan = styled.span<{
  $fontSize: FontSize;
  $color?: string;
  $filled?: boolean;
}>`
  font-size: ${({ $fontSize }) => fontSizeMap[$fontSize]};
  ${({ $color }) => $color && `color: ${$color};`}
  ${({ $filled }) => $filled && `font-variation-settings: 'FILL' 1;`}
`;

/**
 * https://developers.google.com/fonts/docs/material_symbols
 * Note: All names must be specified in index.html header link
 */
export default function MaterialSymbol({
  icon,
  color,
  fontSize = 'default',
  className,
  onClick,
  filled,
  rounded,
}: {
  icon: (typeof allMaterialSymbols)[number];
  color?: string;
  fontSize?: FontSize;
  className?: string;
  onClick?: MouseEventHandler | undefined;
  filled?: boolean;
  // TODO: katana icons maybe okay to only use rounded and not outlined at all ?
  /** @deprecated TODO: katana icons rounded not yet imported in index.html. Probably best to create extra MaterialSymbolRounded component so we can have different list of icons for that. */
  rounded?: boolean;
}) {
  return (
    <IconSpan
      className={`material-symbols-${rounded ? 'rounded' : 'outlined'}  ${
        className || ''
      }`}
      $fontSize={fontSize}
      $color={color}
      $filled={filled}
      onClick={onClick}
    >
      {icon}
    </IconSpan>
  );
}
